import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Signup from '@/components/Signup'
import Signin from '@/components/Signin'
import Signout from '@/components/Signout'
import { auth } from '@/firebase/firebase'
import NewPlace from '@/components/NewPlace'
import Place from '@/components/Place'
import Map from '@/components/Map'


Vue.use(Router)

let router = new Router({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  }, {
    path: '/map',
    name: 'Map',
    component: Map,
  }, { //2.追加
    path: '/place/add',
    name: 'NewPlace',
    component: NewPlace,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/signup',
    name: 'Signup',
    component: Signup
  }, {
    path: '/signin',
    name: 'Signin',
    component: Signin
  }, {
    path: '/signout',
    name: 'Signout',
    component: Signout
  }, {
    path: '/place/:placeId',
    name: 'Place',
    component: Place,
  }, {
    path: '/place/edit/:placeId',
    name: 'EditPlace',
    component: NewPlace,
    meta: {
      requiresAuth: true
    }
  }]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    auth.onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        next({
          path: '/signin',
          query: {
            redirect: to.fullPath
          }
        })
      }
    })
  } else {
    next() // next() を常に呼び出すようにしてください!
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js